import React from 'react'
import Title from '../../components/typography/title.component'
import Container from '../../components/layout/container.component'
import getUrlParameter from '../../helpers/url.helper'
import ModalNotVerified from './components/modal-not-verified'
import { routes } from '../../constants/routes.constants'
import { connect } from 'react-redux'
import { LoginForm } from './components/login-form.component'
import { withRouter } from 'react-router-dom'
import { StorageService, MuvicardService } from '../../services'
import { ClientService } from '../../services'
import { RoleConstants } from './../../constants'
import { SubscribeForNews } from '../../components/layout/subscribe-for-news.component'
import { AuthenticationService } from '../../services/authentication.service'
import { Creators as SiteCreators } from '../../ducks/site/site'
import { toastActions, userActions } from './../../actions'
import TicketSaleService from '../../services/ticket-sale.service'
import { Creators as TripSearchCreators } from '../../ducks/trip-search/trip-search'
import { parseJwt } from '@helpers'

class LoginPageComponent extends React.Component {
	constructor(props) {
		super(props)
		this.user = { login: '', password: '' }
		this.state = {
			loaded: false,
			modalNotVerifiedIsOpen: false,
		}
	}

	componentWillMount() {
		const { showLoading, hideLoading, user } = this.props
		showLoading()
		if (user) {
			handleRedirect.call(this)
		} else {
			this.setState(
				{
					loaded: true,
				},
				() => hideLoading()
			)
		}
	}

	handleSuccessfulAuthentication = async ({ success, errors, data: user }) => {
		const {
			userLogin,
			setAccessToken,
			hideLoading,
			warning,
			muvibus,
			setLoadingOrigins,
			setOrigins,
		} = this.props

		if (success) {
			const { role } = parseJwt(user.accessToken)

			setAccessToken(user.accessToken)

			let { data, success: muvicardSuccess } =
				await MuvicardService.GetCardInfo()

			if (muvicardSuccess) {
				user = { ...user, muvicardData: data }
			}

			let isRequester = role.some((role) => role === RoleConstants.Requester)

			user = { ...user, roles: role, isRequester }

			userLogin(user)

			StorageService.authentication.user.set(user)

			ClientService.getSubscription().then(
				({ data: plan, errors, success }) => {
					if (success) {
						user.plan = plan
						userLogin(user)
					} else {
						warning({ message: errors[0] })
						userLogin(user)
					}
				}
			)

			var customerID = user.id // define o ID do cliente
			;(function () {
				var period = 300
				var limit = 20 * 1e3
				var nTry = 0
				var intervalID = setInterval(function () {
					// loop para retentar o envio
					var clear = limit / period <= ++nTry
					if (
						typeof Konduto !== 'undefined' &&
						typeof Konduto.setCustomerID !== 'undefined'
					) {
						window.Konduto.setCustomerID(customerID) // envia o ID para a Konduto
						clear = true
					}
					if (clear) {
						clearInterval(intervalID)
					}
				}, period)
			})(customerID)

			//Atualizar origens para usuários de orgão publico
			if (user.hasPublicBody) {
				let muvibusState = false
				if (muvibus) {
					muvibusState = true
				}
				setTimeout(() => {
					setLoadingOrigins()
					TicketSaleService.getOrigins(
						muvibusState,
						user.hasPublicBody,
						user.id
					).then(({ data }) => {
						setOrigins(data)
					})
				})
			}

			handleRedirect.call(this)
		} else {
			hideLoading()
			handleLoginFail.call(this, errors)
		}
	}

	async submit(values, actions) {
		const { login, password } = values
		const { showLoading, hideLoading } = this.props

		showLoading()

		actions.validateForm(values)
		actions.setSubmitting(false)

		AuthenticationService.authenticate(login, password)
			.then(await this.handleSuccessfulAuthentication)
			.catch(({ response }) => {
				hideLoading()
				if (response && response.status === 403) {
					this.user = { login, password }
					this.setState({ modalNotVerifiedIsOpen: true })
				} else {
					this.props.danger(
						'Não foi possível efetuar o login, por favor tente novamente mais tarde'
					)
				}
			})
	}

	render() {
		const { loaded } = this.state
		return loaded ? (
			<div>
				<Container>
					<Title>Acesse a sua conta!</Title>
					<LoginForm
						successfulAuthentication={this.handleSuccessfulAuthentication}
						handleSubmit={this.submit.bind(this)}
						user={this.user}
					/>
				</Container>
				<SubscribeForNews />
				<ModalNotVerified
					onClose={() => this.setState({ modalNotVerifiedIsOpen: false })}
					isOpen={this.state.modalNotVerifiedIsOpen}
					onConfirm={async () => {
						const { login, password } = this.user
						const { showLoading, hideLoading } = this.props
						showLoading()
						AuthenticationService.resendEmailConfirmation(login, password)
							.then(({ success, errors }) => {
								this.setState({ modalNotVerifiedIsOpen: false })
								if (success) {
									this.props.success('E-mail enviado com sucesso.')
								} else {
									this.props.danger(
										(errors && errors.length && errors[0]) ||
											'Não foi possível enviar o e-mail de confirmação, por favor tente novamente mais tarde'
									)
								}
								hideLoading()
							})
							.catch(() => {
								this.props.danger(
									(errors && errors.length && errors[0]) ||
										'Não foi possível enviar o e-mail de confirmação, por favor tente novamente mais tarde'
								)
								hideLoading()
							})
					}}
				/>
			</div>
		) : null
	}
}

function handleRedirect() {
	const { user } = this.props
	const userFirstRole =
		user && user.roles && user.roles.length ? user.roles[0] : ''
	redirectUser.call(this, userFirstRole)
}

function redirectUser(role) {
	const {
		history,
		location,
		hideLoading,
		menuOptionPath,
		menuOptionPathFunc,
	} = this.props
	const { redirectUrl } = (location && location.state) || {}
	const redirectUrlFromQuery = getUrlParameter('redirecionamento')

	hideLoading()

	if (redirectUrl) history.push(redirectUrl)
	else if (redirectUrlFromQuery) history.push(redirectUrlFromQuery)
	else {
		let pathname = ''
		switch (role) {
			case RoleConstants.Admin:
				pathname = routes.ADMIN
				break
			case RoleConstants.Client:
				if (menuOptionPath !== '') pathname = menuOptionPath
				else pathname = '/'
				break
			case RoleConstants.Partner:
				pathname = routes.PARCEIRO
				break
		}

		menuOptionPathFunc('')
		history.push(pathname)
	}
}

function handleLoginFail(errors) {
	const hasMessage = Array.isArray(errors) && errors.length
	if (hasMessage) {
		this.props.warning(errors[0])
	} else {
		this.props.danger(
			'Não foi possível efetuar o login, por favor tente novamente mais tarde'
		)
	}
}

const mapStateToProps = ({ toast, user, site }) => {
	return {
		...toast,
		user: user,
		menuOptionPath: site.menuOptionPath,
	}
}
const mapDispatchToProps = (dispatch) => {
	return {
		success: (message, options) =>
			dispatch(toastActions.success({ message, options })),
		warning: (message, options) =>
			dispatch(toastActions.warning({ message, options })),
		danger: (message, options) =>
			dispatch(toastActions.danger({ message, options })),
		showLoading: () => dispatch(SiteCreators.showLoading()),
		hideLoading: () => dispatch(SiteCreators.hideLoading()),
		userLogin: (user) => dispatch(userActions.login(user)),
		setAccessToken: (accessToken) =>
			dispatch(userActions.setAccessToken(accessToken)),
		menuOptionPathFunc: (option) =>
			dispatch(SiteCreators.menuOptionPath(option)),
		setLoadingOrigins: () => dispatch(TripSearchCreators.setLoadingOrigins),
		setOrigins: (data) => dispatch(TripSearchCreators.setOrigins(data)),
	}
}

const connectedLoginPageComponent = withRouter(
	connect(mapStateToProps, mapDispatchToProps)(LoginPageComponent)
)

export { connectedLoginPageComponent as ModuleRootComponent }
